import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const AISearchPage: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-AISearchMain" */ './AISearchMain.tsx'))
			.AISearchMain,
});
